module.exports = __webpack_public_path__ + "static/media/icon_uc.1d8b7141.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/resources/os/icon_uc.svg
// module id = 1337
// module chunks = 0